import './ImageSquare.css';

export default function ImageSquare({
                                        image,
                                        manageImageChange,
                                        index,
                                        currentImageIndex,
                                        length,
    alt,
                                        isActive,
                                        refCb
                                    }) {
    return (
        <div
            ref={refCb}
            className={isActive ? "image-square image-square--active" : "image-square"}
            onClick={() => manageImageChange(index, 'change')}
            role="button"
            aria-label={`Wybierz miniaturę ${index + 1} z ${length}`}
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    manageImageChange(index, 'change');
                }
            }}
        >
            <div className="image-square-main">
                <img loading="lazy" src={image} alt={alt || `Miniatura ${index + 1}`} />
            </div>
        </div>
    );
}
